import {Checkboxes, Fieldset} from "nhsuk-react-components"
import * as React from "react"
import {
  VALUE_SET_PRESCRIPTION_CHARGE_EXEMPTION
} from "../../fhir/reference-data/valueSets"
import SelectField, {convertCodingsToOptions} from "../common/selectField"
import {FormikProps, getIn} from "formik"

interface ExemptionProps {
  name: string
  form: FormikProps<any>
}

const Exemption: React.FC<ExemptionProps> = ({
  name, form
}) => (
  <Fieldset>
    <Fieldset.Legend size="m">Prescription Charge Exemption</Fieldset.Legend>
    <SelectField
      id={`${name}.code`}
      name={`${name}.code`}
      label="Exemption Status"
      fieldOptions={convertCodingsToOptions(VALUE_SET_PRESCRIPTION_CHARGE_EXEMPTION)}
    />
    <Checkboxes id={`${name}.evidenceSeen.boxes`}>
      <Checkboxes.Item
        id={`${name}.evidenceSeen.box`}
        name={`${name}.evidenceSeen`}
        type="checkbox"
        checked={!!getIn(form.values, `${name}.evidenceSeen`)}
        onChange={form.handleChange}
        onBlur={form.handleBlur}
      >
        Evidence Seen
      </Checkboxes.Item>
    </Checkboxes>
  </Fieldset>
)

export default Exemption
